<p-splitButton
  *ngIf="hasMenuItems"
  [label]="defaultTooltip"
  icon="icon_ion_document"
  (onClick)="activateDefault()"
  class="bfx-button-primary-bold-unsized bfx-button-sm new-order-button"
  [model]="menuItems"
  menuStyleClass="bfx-dashboard-menu"
>
</p-splitButton>

<!--
<button
  #singleButton
  id="single-button"
  pButton
  type="button"
  class=""
  [ngClass]="{
    appbar_app_buttons: true,
    single_order_entry: hasMultipleMenuItems
  }"
  title="menu.visible ? '' : defaultTooltip"
  (click)="activateDefault(menu, $event)"
  placement="bottom"
  [disabled]="!hasMenuItems"
>
  <span class="icon-bfx_new_order"></span>
</button>
<button
  id="multi-button"
  pButton
  type="button"
  [ngClass]="{
    appbar_app_buttons: true,
    multi_order_entry: hasMultipleMenuItems
  }"
  placement="bottom"
  (click)="toggle(menu, $event)"
  [disabled]="!hasMenuItems || !hasMultipleMenuItems"
  [style.display]="hasMultipleMenuItems ? 'inline-block' : 'none'"
  title="menu.visible ? '' : 'New Order...'"
>
  <span class="fa fa-fw icon-triangle_down"></span>
</button>
-->
